import { computed, reactive, ref } from 'vue'

/** 选项批量编辑 */
export default function useOptionsEdit({
  getOptions,
  callback
}: {
  /** 获取选项列表 */
  getOptions: () => string[]
  /** 编辑成功回调 */
  callback: (options: string[]) => void
}) {
  /** 是否可见 */
  const visible = ref(false)

  return reactive({
    /** 是否可见 */
    visible,

    /** 选项列表 */
    options: computed(getOptions),

    /** 导入选项列表 */
    import: callback
  })
}
